import ReactDOM from "react-dom";
import React, { useEffect, useState } from "react";
import BooleanButton from "../../../../../../merchant/panel/scripts/shared/button/booleanButton.js";
import "../../../../../../shared/styles/colorDefinitions.css";
import "../../../../../../merchant/panel/style.css";
import "../../../../../../shared/styles/buttonStyles.css";
import "./style.css";
import { ToastContainer } from "react-toastify";
import { parse } from "query-string";
import LoadingComponent from "../../../../shared/ui/animations/loading.js";
import executeRequest from "../../../../modules/request.js";
import { showError } from "../../gallery/scripts/showError.js";
import { patch } from "../../../../modules/patch.js";
export function Container() {
    const [emailsEnabled, setEmailsEnabled] = useState(undefined);
    const { key, orderId } = parse(location.search);
    useEffect(() => {
        executeRequest(`/api/public/users/order/${orderId}?key=${key}`, "GET", {}).then((res) => {
            if (res.status == 200) {
                setEmailsEnabled(!res.emailsBlocked);
            }
            else {
                showError("Nie udało się załadować danych");
            }
        });
    }, []);
    if (!key || !orderId) {
        return React.createElement(React.Fragment, null, "Nieprawid\u0142owe rz\u0105danie");
    }
    if (emailsEnabled === undefined)
        return React.createElement(LoadingComponent, { color: "classic" });
    return (React.createElement("div", { className: "container" },
        React.createElement("div", { className: "settings-container" },
            React.createElement(BooleanButton, { label: "Otrzymuj e-maile przygotowywane przez fotografa", defaultState: emailsEnabled, onClick: async (enabled) => {
                    setEmailsEnabled(enabled);
                    const res = await patch(`/api/public/users/order/${orderId}/email-notifications?key=${key}`, {
                        blockEmailNotifications: !enabled,
                    });
                    if (res.status === 200)
                        return;
                    window.location.reload();
                } }),
            emailsEnabled === false && (React.createElement(React.Fragment, null,
                "Nie b\u0119dziesz otrzymywa\u0107 \u017Cadnych wiadomo\u015Bci mailowych",
                React.createElement("br", null),
                "zwi\u0105zanych z tym zam\u00F3wieniem!"))),
        React.createElement(ToastContainer, { position: "top-left", hideProgressBar: true })));
}
// eslint-disable-next-line react/no-deprecated
ReactDOM.render(React.createElement(Container, null), document.body.querySelector("#container"));
